import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d2900900&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vincent/Documents/Développement/Stadia Fr/Jeux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2900900')) {
      api.createRecord('d2900900', component.options)
    } else {
      api.reload('d2900900', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=d2900900&", function () {
      api.rerender('d2900900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/javascripts/App.vue"
export default component.exports